import router from "../router";

import {getLocalStorage, addLocalStorage} from "@songfinch/utils/src/storage";

import type {RouteLocationNormalized} from "vue-router";

import type {NavigationGuardNext} from "vue-router";

type LastReferralPageRoute = {
    name: string,
    query?: Record<string, string>,
    params?: Record<string, string>,
}

type LastReferralPage = LastReferralPageRoute | Record<string, never>;

export const setLastReferralPage = (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext
) => {
    if (
        from.matched[0] &&
        from.matched[0]?.name !== to.matched[0]?.name
    ) {
        addLocalStorage("sf_last_referral_page", {
            name: from.name as string,
            params: from.params as Record<string, string>,
            query: from.query as Record<string, string>,
        });
    }
    next();
};

export function goToReferalPage() {
    const value = getLocalStorage<LastReferralPage>("sf_last_referral_page");
    let page: LastReferralPageRoute | undefined;
    try {
        if (value && typeof value === "object" && "name" in value && typeof value.name === "string") {
            // Validate route before using
            router.resolve(value);
            page = {
                name: value.name,
                params: value.params,
                query: value.query,
            };
        }
    } catch (e) {
        page = undefined;
    }
    if (!page) {
        const defaultRoutePage = router.currentRoute.value.matched[0]?.meta?.defaultReferralPage;
        page = defaultRoutePage
            ? {name: String(defaultRoutePage)}
            : {name: "Home"};
    }
    router.push(page);
}
